<div class="usuarios-container px-3 py-4">
  <h5 class="mb-3">{{ 'parametrizacion.titulo' | translate }}</h5>
  <div class="usuarios-table">
    <!-- Encabezados de la tabla -->
    <app-table
      [estiloEncabezado]="'height: auto !important;'"
      *ngIf="true"
      [datos]="parametrizacion"
      [columnas]="columnasParametrizacion"
      [acciones]="accionesParametrizacion"
      [paginacion]="true"
      (eventoAccion)="editarParametrizacion($event)"
      [paginaActual]="paginaActual"
      [totalPaginas]="totalPaginas"
      [tamano]="tamanoPagina"
      [multipleSelection]="false"
      [idColumn]="'id'"></app-table>
  </div>
  <app-form-editar-parametrizacion
    (parametrizacionActualizado)="
      cargarParametrizacion()
    "></app-form-editar-parametrizacion>
</div>
